import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

// comentamos estas importaciones, aun no se que hacen.
//import { Provider } from "react-redux";
//import { store } from "./store/store";
import { useAuth } from "./hooks/useAuth";

import { ThemeType, toggleTheme } from "@scuf/common";

import "@scuf/common/honeywell-compact-combined/theme.css";
import "@scuf/charts/honeywell-compact-combined/theme.css";

import Layout from "./pages/Layout/LayoutFuncional";
import Login from "./pages/Login/Login";
import Home from "./pages/Home/Home";
import APC from "./pages/APC/APC";
import DAPC from "./pages/DAPC/DAPC";
import Domo from "./pages/Domo/Domo";
import Tostador from "./pages/Tostador/Tostador";
import PAcido from "./pages/PAcido/PAcido";
import PTEfluente from "./pages/PTEfluente/PTEfluente";
import LGases from "./pages/LGases/LGases";
import TGases from "./pages/TGases/TGases";
import Despacho from "./pages/Despacho/Despacho";
import BProd from "./pages/BProd/BProd";
import CargaData from "./pages/CargaData/CargaData";
import Domo2 from "./pages/Domo2/Domo2";
import AnimationDomoPage from "./pages/AnimationDomo/AnimationDomoPage";
import PreferencesPage from "./pages/PreferencesPage/PreferencesPage";
import PFDTostacionPage from "./pages/PFDTostacion/PFDTostacionPage";
import LoginLindo from "./pages/Login/LoginLindo";
import PlgEtp from "./pages/PLG-ETP/Plg-etp";

/**
 * Retorna las rutas de la aplicacion
 * @returns
 */
export default function RouteConfig() {
  // Configuramos el tema oscuro por defecto
  useEffect(() => {
    toggleTheme(ThemeType.Dark);
  }, []);

  const PrivateRoute = ({ children }) => {
    const { token } = JSON.parse(localStorage.getItem("user")) || false;

    return (
      <Route
        render={() =>
          token ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/login",
              }}
            />
          )
        }
      />
    );
  };

  return (
    <>
      <Router>
        <Switch>
          <Route path="/" exact component={LoginLindo} />
          <Route path="/login" component={LoginLindo} />

          <PrivateRoute path="/estrategico">
            <Layout route="estratégico" component={<Home />} />
          </PrivateRoute>

          <PrivateRoute path="/apc">
            <Layout route="apc" component={<APC />} />
          </PrivateRoute>

          <PrivateRoute path="/dapc">
            <Layout route="dapc" component={<DAPC />} />
          </PrivateRoute>

          <PrivateRoute path="/domo">
            <Layout route="domo" component={<Domo />} />
          </PrivateRoute>

          <PrivateRoute path="/tostador">
            <Layout route="tostador" component={<Tostador />} />
          </PrivateRoute>

          <PrivateRoute path="/pacido">
            <Layout route="pacido" component={<PAcido />} />
          </PrivateRoute>

          <PrivateRoute path="/tgases">
            <Layout route="tgases" component={<TGases />} />
          </PrivateRoute>

          <PrivateRoute path="/lgases">
            <Layout route="lgases" component={<LGases />} />
          </PrivateRoute>

          <PrivateRoute path="/ptefluentes">
            <Layout route="ptefluente" component={<PTEfluente />} />
          </PrivateRoute>

          <PrivateRoute path="/despacho">
            <Layout route="despacho" component={<Despacho />} />
          </PrivateRoute>

          <PrivateRoute path="/bproduccion">
            <Layout route="bprod" component={<BProd />} />
          </PrivateRoute>

          <PrivateRoute path="/cdata">
            <Layout route="cdata" component={<CargaData />} />
          </PrivateRoute>

          <PrivateRoute path="/domo2">
            <Layout route="domo2" component={<Domo2 />} />
          </PrivateRoute>

          <PrivateRoute path="/animated-domo">
            <Layout route="animated-domo" component={<AnimationDomoPage />} />
          </PrivateRoute>

          <PrivateRoute path="/preferencias">
            <Layout route="preferencias" component={<PreferencesPage />} />
          </PrivateRoute>

          <PrivateRoute path="/PFD-tostacion">
            <Layout route="PFD-tostacion" component={<PFDTostacionPage />} />
          </PrivateRoute>

          <PrivateRoute path="/plg-etp">
            <Layout route="plg-etp" component={<PlgEtp />} />
          </PrivateRoute>
        </Switch>
      </Router>
    </>
  );
}
